// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".element__span[data-v-4adabb02] {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: pre;\n  min-width: 100px;\n  width: -moz-fit-content;\n  width: fit-content;\n  flex: 3;\n}", ""]);
// Exports
module.exports = exports;
